import { Directive, HostListener, Input } from '@angular/core';

@Directive({ selector: '[cancelContextMenu]' })
export class CancelContextMenuDirective {
    @Input('cancelContextMenu') allow:boolean;
    @HostListener('contextmenu', ['$event']) onContextMenu(event) {
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
}


// WEBPACK FOOTER //
// ./web/static/services/directives/CancelContextMenu.ts